import type { Hub, User } from '$lib/api/rpc';
import { atLeastModerator } from '$lib/utils/roles';

export const getQuickPollURL = ({
	quickPollUrl,
	hub,
	user,
}: {
	quickPollUrl: string | undefined;
	hub: Hub;
	user: User;
}) => {
	if (!quickPollUrl) return '';
	try {
		const url = new URL(quickPollUrl);

		url.searchParams.set('scroll', 'off');

		if (atLeastModerator(hub.user_context)) {
			url.searchParams.set('preview', 'true');
		}
		// TODO: this feels like the wrong place to take the community id from
		if (hub.type == 'sparq3member' && hub.settings.CommunitySignupPageContent) {
			url.searchParams.set('source', 'member_hub');
			url.searchParams.set('collection_id', hub.settings.CommunitySignupPageContent.CommunityId);
			url.searchParams.set('external_id', hub.user_context.member_id);
		} else if (hub.type == 'sparq3stakeholder') {
			url.searchParams.set('source', 'stakeholder_hub');
			url.searchParams.set('collection_id', hub.id);
			url.searchParams.set('external_id', user.id);
		}
		return url.toString();
	} catch (e) {
		return '';
	}
};
